import io from 'socket.io-client'
import Config from './helper/config'
export const socket = io(Config.Back_URL, {
    upgrade: false, reconnection: true,
    reconnectionAttempts: Infinity,
})
export var SocketId;
socket.on('connected', () => {
    SocketId = socket.id
})